import { Injectable } from '@angular/core';
import { AssistanceReport } from '../models/report/assistance-report';
import { ServiceBase } from './base/service-base.service';
import { AlertService } from './alert.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssistanceReportService extends ServiceBase {
  private baseUrl = '/api/report/assistance/';

  constructor(authhttp: HttpClient, alert: AlertService) {
      super(authhttp);
  }

  create(report: AssistanceReport): Observable<AssistanceReport> {
      return this.postJson<AssistanceReport>(this.baseUrl + "create", report);
  }

  get(reportId: number): Observable<AssistanceReport> {
      return this.getJson<AssistanceReport>(this.baseUrl + "get/" + reportId);
  }

  update(report: AssistanceReport): Observable<AssistanceReport> {
      return this.postJson<AssistanceReport>(this.baseUrl + "update", report);
  }
}
